import type { TFunction } from 'i18next';
import type { DispensasjonType, DispensasjonFra } from '@origo/planregister';
import type { SelectOption } from '../types';

const TYPE_CODES: DispensasjonType[] = [
    '100', '110', '111', '120', '130', '140', '141', '142', '143',
    '150', '160', '161', '162', '163', '165', '170', '171', '172',
    '173', '174', '200', '300', '400', '500',
];

const FRA_CODES: DispensasjonFra[] = ['ARB', 'PLAN', 'TEK', 'FORU', 'JORD', 'KOM', 'PBL', 'VEG'];

export function dispensasjonTypeLabel(code: DispensasjonType | string | undefined, t: TFunction): string {
    if (!code) return '';
    return t(`codelists.dispensasjonType.${code}`, { defaultValue: code });
}

export function dispensasjonTypeOptions(t: TFunction): SelectOption[] {
    return TYPE_CODES.map(code => ({ value: code, label: dispensasjonTypeLabel(code, t) }));
}

export function dispensasjonFraLabel(code: DispensasjonFra | string | undefined, t: TFunction): string {
    if (!code) return '';
    return t(`codelists.dispensasjonFra.${code}`, { defaultValue: code });
}

export function dispensasjonFraOptions(t: TFunction): SelectOption[] {
    return FRA_CODES.map(code => ({ value: code, label: dispensasjonFraLabel(code, t) }));
}
